/* ==========================================================================
   TOTE - CRO split test round 4 (T66-T84) behaviour
   Kopstorm CommV

   Mode mirroring
   --------------
   Each test ships a hidden gated marker [data-kv-test="TXX"] inside
   .kv-r4-modes. When Intelligems reveals a marker, the matching class is
   mirrored onto the html element (kv-t66, kv-t67 ...) and the CSS in
   kv-tests-r4.css takes effect. Adding the class straight from Intelligems
   variant JS also works and survives AJAX rerenders, which is the route to
   use in production.

   The id list lives in TWO places, this array and the liquid snippet. A new
   mode has to be added to both or the marker never becomes a class.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__kvTestsR4Init) return;
  window.__kvTestsR4Init = true;

  var IDS = ['T66', 'T67', 'T68', 'T69', 'T70', 'T71', 'T72', 'T73', 'T74',
             'T75', 'T76', 'T77', 'T78', 'T79', 'T80', 'T81', 'T82', 'T84', 'T85'];

  /* The R3 upsells and the T65 colour slider live in their own layers but
     ship in the same theme, so the panel and the ?kv= links drive them too.
     One theme, one switchboard, everything testable side by side. */
  var NEIGHBOURS = ['T60', 'T61', 'T62', 'T63', 'T64', 'T65'];

  var LABELS = {
    T66: 'T66 gallery response',
    T67: 'T67 five image gallery',
    T68: 'T68 stacked mobile gallery',
    T69: 'T69 model switcher',
    T70: 'T70 one line answer',
    T71: 'T71 compressed fold',
    T72: 'T72 range rail',
    T73: 'T73 short hero',
    T74: 'T74 two paths',
    T75: 'T75 set completion',
    T76: 'T76 shipping gap solved',
    T77: 'T77 second colour nudge',
    T78: 'T78 visual menu',
    T79: 'T79 compact cookie bar',
    T80: 'T80 add two colours',
    T81: 'T81 bundle discovery',
    T82: 'T82 shipping truth',
    T84: 'T84 payment order',
    T85: 'T85 model tabs with images',
    T60: 'T60 second bag offer (R3)',
    T61: 'T61 accessory add-on prices (R3)',
    T62: 'T62 set or single (R3)',
    T63: 'T63 reverse offer, accessories (R3)',
    T64: 'T64 ready made sets (R3)',
    T65: 'T65 colour slider on the PDP (R3)'
  };

  var root = document.documentElement;
  var CFG = readJson('[data-kv-r4-config]') || {};
  var ACCESSORIES = readJson('[data-kv-r4-accessories]') || [];
  var BAGS = readJson('[data-kv-r4-bags]') || { groups: [], types: [], accTypes: [] };

  /* id -> index of the collection group it belongs to. The nudge offers other
     colours of the SAME model, so the group is what decides the swatches: an
     ALTA in the cart can only ever offer other ALTAs. */
  var BAG_GROUPS = BAGS.groups || [];
  var BAG_IDS = {};
  BAG_GROUPS.forEach(function (g, gi) {
    (g.items || []).forEach(function (row) {
      if (BAG_IDS[String(row[0])] === undefined) BAG_IDS[String(row[0])] = gi;
    });
  });
  var BAG_TYPES = {};
  (BAGS.types || []).forEach(function (t) {
    if (t) BAG_TYPES[String(t).toLowerCase()] = true;
  });
  (BAGS.accTypes || []).forEach(function (t) {
    if (t) delete BAG_TYPES[String(t).toLowerCase()];
  });

  /* T77 is a BAG offer. It must never render under a carabiner or a bottle,
     and the colours it offers have to be bags as well. The id list is the
     real test and fails closed; the type list only catches products past
     the 50 per collection ceiling a Liquid loop has, and every accessory
     type has already been subtracted from it. */
  function isBagProduct(id, type) {
    if (id != null && BAG_IDS[String(id)] !== undefined) return true;
    var t = String(type || '').toLowerCase().trim();
    return !!(t && BAG_TYPES[t]);
  }

  /* Every other colour in the same collection, in the merchant's own order,
     minus anything already in the cart. Returns null when the product is not
     in any group, so the caller can fall back to recommendations. */
  function sameCollectionColours(productId, exclude) {
    var gi = BAG_IDS[String(productId)];
    if (gi === undefined || !BAG_GROUPS[gi]) return null;
    var out = [];
    (BAG_GROUPS[gi].items || []).forEach(function (row) {
      if (String(row[0]) === String(productId)) return;
      if (exclude && exclude[String(row[0])]) return;
      if (row[4] === 0) return;               /* sold out */
      if (!row[1]) return;                    /* no variant to add */
      out.push({ id: row[0], variantId: row[1], title: row[2], image: row[3] });
    });
    return out;
  }

  function readJson(selector) {
    var node = document.querySelector(selector);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  /* A neighbouring layer only ever ADDS a class from its own marker, so
     switching one off means re-gating the marker as well, otherwise its
     next sync turns the mode straight back on. */
  function setNeighbour(id, state) {
    var cls = 'kv-' + id.toLowerCase();
    var marker = document.querySelector('[data-kv-test="' + id + '"]');
    if (state) {
      if (marker) marker.classList.remove('kv-tt-gated');
      root.classList.add(cls);
    } else {
      if (marker) marker.classList.add('kv-tt-gated');
      root.classList.remove(cls);
    }
  }

  function on(id) {
    return root.classList.contains('kv-' + id.toLowerCase());
  }

  function isVisible(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden';
  }

  /* Modes the preview panel has deliberately switched off. Without this,
     syncModes reads the still visible marker on the next mutation and turns
     the mode straight back on, so the panel appears not to work. */
  var overridden = {};

  function syncModes() {
    var changed = false;
    for (var i = 0; i < IDS.length; i++) {
      var id = IDS[i];
      var cls = 'kv-' + id.toLowerCase();
      if (overridden[id] === false) continue;
      var marker = document.querySelector('.kv-r4-mode[data-kv-test="' + id + '"]');
      if (isVisible(marker) && !root.classList.contains(cls)) {
        root.classList.add(cls);
        changed = true;
      }
    }
    if (changed) boot();
  }

  /* ---- placement helpers --------------------------------------------------
     A block renders once near the top of the body and is MOVED to its slot,
     leaving a comment marker so the move is reversible. product-form is NOT
     a sibling of the custom_liquid blocks (main-product nests it inside the
     buy_buttons wrapper), so containment is tested with
     compareDocumentPosition rather than parentNode equality.
  ------------------------------------------------------------------------ */
  function block(id) {
    return document.querySelector('[data-kv-r4-block="' + id + '"]');
  }

  function place(el, anchor, where) {
    if (!el || !anchor) return false;
    if (el.getAttribute('data-kv-r4-placed') === '1') return true;
    if (!el.__kvMarker) {
      el.__kvMarker = document.createComment('kv-r4 ' + (el.getAttribute('data-kv-r4-block') || ''));
      el.parentNode.insertBefore(el.__kvMarker, el);
    }
    if (where === 'before') {
      anchor.parentNode.insertBefore(el, anchor);
    } else {
      anchor.parentNode.insertBefore(el, anchor.nextSibling);
    }
    el.setAttribute('data-kv-r4-placed', '1');
    el.hidden = false;
    return true;
  }

  function unplace(el) {
    if (!el || el.getAttribute('data-kv-r4-placed') !== '1') return;
    if (el.__kvMarker && el.__kvMarker.parentNode) {
      el.__kvMarker.parentNode.insertBefore(el, el.__kvMarker);
    }
    el.removeAttribute('data-kv-r4-placed');
    el.hidden = true;
  }

  function productForm() {
    return document.querySelector('product-form.product-form, product-form form, form.product-form');
  }

  /* The payment icons row sits in its own custom_liquid wrapper after the
     form on 50 templates. Everything that belongs under the buy box goes
     below that row, per the 14 Aug feedback on R3. */
  function afterBuyAnchor() {
    var form = productForm();
    if (!form) return null;
    var icons = document.querySelector('.custom-payment-icons');
    if (icons) {
      var wrap = icons.closest('.custom-liquid') || icons.parentNode;
      if (wrap && wrap !== form) {
        var rel = form.compareDocumentPosition(wrap);
        var follows = !!(rel & Node.DOCUMENT_POSITION_FOLLOWING);
        var contains = !!(rel & Node.DOCUMENT_POSITION_CONTAINED_BY) ||
                       !!(rel & Node.DOCUMENT_POSITION_CONTAINS);
        if (follows && !contains) return wrap;
      }
    }
    return form;
  }

  function galleries() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.product__media-list.swiper, .product__media-list.js-media-list, .product__media-list.js-media-list-mobile')
    );
  }

  function slidesOf(gallery) {
    var wrap = gallery.querySelector('.swiper-wrapper') || gallery;
    return Array.prototype.slice.call(wrap.children).filter(function (n) {
      return n.classList && n.classList.contains('product__media-item');
    });
  }

  /* ======================================================================
     T66 - gallery response time
     ====================================================================== */
  function t66() {
    if (!on('T66')) return;
    galleries().forEach(function (gallery) {
      if (gallery.getAttribute('data-kv-r4-t66') === '1') return;
      gallery.setAttribute('data-kv-r4-t66', '1');

      slidesOf(gallery).slice(0, 4).forEach(function (slide) {
        Array.prototype.forEach.call(slide.querySelectorAll('img'), function (img) {
          img.loading = 'eager';
          img.setAttribute('fetchpriority', 'high');
          if (img.dataset && img.dataset.src && !img.src) img.src = img.dataset.src;
        });
      });

      if (gallery.swiper && gallery.swiper.params) {
        gallery.swiper.params.speed = 0;
      }

      ['.swiper-button-next', '.swiper-button-prev'].forEach(function (sel) {
        var btn = gallery.querySelector(sel);
        if (!btn) return;
        btn.addEventListener('pointerdown', function () {
          btn.classList.add('kv-r4-pressed');
        });
        ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
          btn.addEventListener(ev, function () {
            btn.classList.remove('kv-r4-pressed');
          });
        });
      });
    });
  }

  /* ======================================================================
     T67 - five image gallery
     ====================================================================== */
  function t67() {
    galleries().forEach(function (gallery) {
      var slides = slidesOf(gallery);
      if (!slides.length) return;
      var keep = parseInt(CFG.galleryKeep, 10) || 5;
      var column = gallery.closest('.product__media-list-wrapper') || gallery.parentNode;

      if (!on('T67')) {
        restoreGallery(gallery, column, slides.length);
        return;
      }
      if (slides.length <= keep) {
        restoreGallery(gallery, column, slides.length);
        return;
      }

      /* set AND unset, so an arm that raises the count at runtime widens the
         reel instead of leaving the earlier trim in place */
      slides.forEach(function (s, i) {
        if (i >= keep) {
          s.setAttribute('data-kv-r4-trimmed', '1');
          s.style.display = 'none';
        } else if (s.hasAttribute('data-kv-r4-trimmed')) {
          s.removeAttribute('data-kv-r4-trimmed');
          s.style.display = '';
        }
      });

      /* the thumbnail rail has to be trimmed with it, otherwise the strip
         still offers photos the reel no longer holds */
      thumbsOf(gallery).forEach(function (t, i) {
        if (i >= keep) {
          t.setAttribute('data-kv-r4-trimmed', '1');
          t.style.display = 'none';
        } else if (t.hasAttribute('data-kv-r4-trimmed')) {
          t.removeAttribute('data-kv-r4-trimmed');
          t.style.display = '';
        }
      });

      setCounterTotal(keep);

      /* The control must sit OUTSIDE .product__media-list-wrapper. Inside it
         becomes a grid item of the thumbs-aside layout and pushes the reel
         and the rail apart, which is what made the gallery look broken. */
      var host = column && column.parentNode;
      if (host && !host.querySelector('.kv-r4-seeall')) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kv-r4-seeall';
        btn.textContent = (CFG.labels && CFG.labels.seeAll) || 'See all photos';
        btn.addEventListener('click', function () {
          restoreGallery(gallery, column, slidesOf(gallery).length);
        });
        host.insertBefore(btn, column.nextSibling);
      }
    });
  }

  function thumbsOf(gallery) {
    var wrapper = gallery.closest('.product__media-list-wrapper') ||
                  gallery.closest('.product__media-wrapper') || document;
    return Array.prototype.slice.call(wrapper.querySelectorAll('.product__media-subitem'));
  }

  function setCounterTotal(n) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-kv-r2-total]'), function (el) {
      if (!el.hasAttribute('data-kv-r4-total-was')) {
        el.setAttribute('data-kv-r4-total-was', el.textContent);
      }
      el.textContent = String(n);
    });
  }

  function restoreGallery(gallery, column, total) {
    Array.prototype.forEach.call(
      (column || document).querySelectorAll('[data-kv-r4-trimmed]'),
      function (n) {
        n.removeAttribute('data-kv-r4-trimmed');
        n.style.display = '';
      }
    );
    slidesOf(gallery).forEach(function (s) {
      s.removeAttribute('data-kv-r4-trimmed');
      s.style.display = '';
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-kv-r4-total-was]'), function (el) {
      el.textContent = el.getAttribute('data-kv-r4-total-was');
      el.removeAttribute('data-kv-r4-total-was');
    });
    if (gallery.swiper && typeof gallery.swiper.update === 'function') gallery.swiper.update();
    var host = column && column.parentNode;
    var btn = host && host.querySelector('.kv-r4-seeall');
    if (btn) btn.remove();
  }

  /* ======================================================================
     T68 - stacked mobile gallery
     ====================================================================== */
  function t68() {
    var count = parseInt(CFG.stackCount, 10) || 3;
    var active = on('T68') && window.matchMedia('(max-width: 749px)').matches;
    galleries().forEach(function (gallery) {
      var slides = slidesOf(gallery);
      slides.forEach(function (s, i) {
        if (active && i >= count) {
          s.setAttribute('data-kv-r4-stack-hidden', '1');
        } else {
          s.removeAttribute('data-kv-r4-stack-hidden');
        }
      });
      if (active && gallery.swiper && typeof gallery.swiper.destroy === 'function' && !gallery.__kvR4Destroyed) {
        try {
          gallery.swiper.destroy(false, true);
          gallery.__kvR4Destroyed = true;
        } catch (e) {
          /* leaving the swiper alive still renders, the CSS overrides the row */
        }
      }
    });
  }

  /* ======================================================================
     T69 / T70 / T82 - PDP inserts
     ====================================================================== */
  function pdpBlocks() {
    var models = block('T69');
    var oneline = block('T70');
    var ship = block('T82');

    if (models) {
      if (on('T69') && !on('T85')) {
        var swatches = document.querySelector('.kv-all-varaint-selector') ||
                       document.querySelector('.kv-variant-tabs-outer') ||
                       document.querySelector('.product__info-container .price-wrapper');
        if (swatches) {
          var target = swatches.closest('.product-info-block') || swatches;
          place(models, target, 'before');
        }
      } else {
        unplace(models);
      }
    }

    if (oneline) {
      if (on('T70')) {
        var title = document.querySelector('.product__info-container .product__title') ||
                    document.querySelector('.product__title');
        if (title) place(oneline, title, 'after');
      } else {
        unplace(oneline);
      }
    }

    if (ship) {
      if (on('T82')) {
        var form = productForm();
        if (form) place(ship, form, 'before');
      } else {
        unplace(ship);
      }
    }
  }

  /* ======================================================================
     T85 - model tabs with images, the V2 of T69
     Instead of a separate card row, the grey SIV / TOTE / ALTA bar that
     already sits on the page carries the photo and the price. The T69 row
     stands down whenever T85 is on, they answer the same question.
     ====================================================================== */
  function modelTabs() {
    var bar = document.querySelector('.kv-tab-variant-top');
    var tabs = bar ? Array.prototype.slice.call(bar.children).filter(function (n) {
      return n.classList && n.classList.contains('kv-tab');
    }) : [];
    if (!tabs.length) return;

    if (!on('T85')) {
      bar.classList.remove('kv-r4-tabs', 'kv-r4-tabs--inline', 'kv-r4-tabs--stacked');
      tabs.forEach(function (li) {
        li.classList.remove('kv-r4-tab');
        var link = li.querySelector('a');
        var label = li.getAttribute('data-kv-r4-tablabel');
        /* the label was wrapped, so put the plain text node back rather than
           leaving an empty link behind */
        if (link && label !== null) link.textContent = label;
        li.removeAttribute('data-kv-r4-tablabel');
      });
      return;
    }

    var data = CFG.modelTabs || [];
    if (!data.length) return;

    var inline = String(CFG.tabLayout || 'inline') === 'inline';
    bar.classList.add('kv-r4-tabs');
    bar.classList.toggle('kv-r4-tabs--inline', inline);
    bar.classList.toggle('kv-r4-tabs--stacked', !inline);

    tabs.forEach(function (li, i) {
      if (li.querySelector('[data-kv-r4-tabdeco]')) return;
      var link = li.querySelector('a');
      if (!link) return;

      /* match on the label first, fall back to source order. Model names are
         the same string in every locale, so this is safe to compare. */
      var text = (link.textContent || '').trim();
      var key = text.toLowerCase();
      var entry = null;
      for (var d = 0; d < data.length; d++) {
        if (key && data[d].label && key === String(data[d].label).trim().toLowerCase()) {
          entry = data[d];
          break;
        }
      }
      if (!entry) entry = data[i];
      if (!entry) return;

      li.classList.add('kv-r4-tab');
      li.setAttribute('data-kv-r4-tablabel', text);
      link.textContent = '';

      var deco = document.createElement('span');
      deco.className = 'kv-r4-tab__deco';
      deco.setAttribute('data-kv-r4-tabdeco', '1');
      if (entry.image) {
        var media = document.createElement('span');
        media.className = 'kv-r4-tab__media';
        var img = document.createElement('img');
        img.src = imageUrl(entry.image);
        img.alt = entry.label || text;
        img.loading = 'lazy';
        media.appendChild(img);
        deco.appendChild(media);
      }
      link.appendChild(deco);

      /* name and price share one wrapper so the layout setting only has to
         flip the direction of the link, never rebuild the markup */
      var textWrap = document.createElement('span');
      textWrap.className = 'kv-r4-tab__text';
      textWrap.setAttribute('data-kv-r4-tabtext', '1');

      var name = document.createElement('span');
      name.className = 'kv-r4-tab__name';
      name.textContent = text;
      textWrap.appendChild(name);

      if (entry.price) {
        var price = document.createElement('span');
        price.className = 'kv-r4-tab__price';
        price.setAttribute('data-kv-r4-tabprice', '1');
        writeMoney(price, entry.price);
        textWrap.appendChild(price);
      }
      link.appendChild(textWrap);
    });
  }

  /* ======================================================================
     T72 / T73 / T74 - page template inserts
     ====================================================================== */
  function pageBlocks() {
    var rail = block('T72');
    var paths = block('T74');
    var anchor = document.querySelector('.page-title, .main-page-title, main .shopify-section h1') ||
                 document.querySelector('#MainContent .shopify-section');

    if (rail) {
      if (on('T72') && anchor) place(rail, anchor, 'after');
      else unplace(rail);
    }
    if (paths) {
      if (on('T74') && anchor) place(paths, anchor, 'after');
      else unplace(paths);
    }
  }

  /* ======================================================================
     T78 - visual menu
     ====================================================================== */
  function menuBlock() {
    var menu = block('T78');
    if (!menu) return;
    if (!on('T78')) {
      unplace(menu);
      return;
    }
    var nav = document.querySelector('.menu-drawer__navigation .menu-drawer__menu') ||
              document.querySelector('.menu-drawer__navigation');
    if (nav) place(menu, nav, 'before');
  }

  /* ======================================================================
     T80 - add two colours
     ====================================================================== */
  function twoColours() {
    var form = productForm();
    var existing = document.querySelector('[data-kv-r4-two]');
    if (!on('T80') || !form || !CFG.productId) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;

    var wrap = document.createElement('div');
    wrap.className = 'kv-r4 kv-r4-two';
    wrap.setAttribute('data-kv-r4-two', '1');

    var pct = parseInt(CFG.twoColourPct, 10) || 40;
    var cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'kv-r4-two__cta';
    cta.textContent = ((CFG.labels && CFG.labels.twoColour) || 'Add two colours') + ' - ' + pct + '%';
    wrap.appendChild(cta);

    var hint = document.createElement('span');
    hint.className = 'kv-r4-two__hint';
    hint.textContent = (CFG.labels && CFG.labels.twoColourHint) || '';
    wrap.appendChild(hint);

    cta.addEventListener('click', function () {
      if (wrap.querySelector('.kv-r4-two__picker')) return;
      var curated = curatedColours();
      if (curated.length) {
        wrap.appendChild(buildPicker(curated, form));
        return;
      }
      cta.disabled = true;
      fetchRelated(CFG.productId, 8).then(function (items) {
        cta.disabled = false;
        var clean = sameType(items);
        if (!clean.length) return;
        wrap.appendChild(buildPicker(clean, form));
      });
    });

    var anchor = afterBuyAnchor();
    if (anchor) anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
  }

  function buildPicker(items, form) {
    var picker = document.createElement('div');
    picker.className = 'kv-r4-two__picker';

    var row = document.createElement('div');
    row.className = 'kv-r4-two__row';
    var chosen = null;

    items.forEach(function (p) {
      var opt = document.createElement('button');
      opt.type = 'button';
      opt.className = 'kv-r4-two__opt';
      opt.setAttribute('aria-label', p.title || '');
      if (p.featured_image) {
        var img = document.createElement('img');
        img.src = imageUrl(p.featured_image);
        img.alt = p.title || '';
        img.loading = 'lazy';
        opt.appendChild(img);
      }
      opt.addEventListener('click', function () {
        Array.prototype.forEach.call(row.children, function (c) { c.classList.remove('is-active'); });
        opt.classList.add('is-active');
        chosen = p;
        confirm.disabled = false;
      });
      row.appendChild(opt);
    });

    picker.appendChild(row);

    var confirm = document.createElement('button');
    confirm.type = 'button';
    confirm.className = 'kv-r4-btn kv-r4-two__confirm';
    confirm.textContent = (CFG.labels && CFG.labels.add) || 'Add';
    confirm.disabled = true;
    confirm.addEventListener('click', function () {
      var current = currentVariantId(form);
      if (!current || !chosen) return;
      confirm.disabled = true;
      resolveVariant(chosen).then(function (second) {
        if (!second) {
          confirm.disabled = false;
          return;
        }
        return addLines([
          { id: current, properties: { _kv_r4: 'T80' } },
          { id: second, properties: { _kv_r4: 'T80', _kv_r4_second: 'true' } }
        ]).then(function () {
          confirm.disabled = false;
          openCart();
        });
      });
    });
    picker.appendChild(confirm);

    return picker;
  }

  /* NEVER read form.id on a Shopify product form. The form contains
     <input name="id">, and a named control shadows the element's own id
     property, so form.id returns that input element rather than a string. */
  function currentVariantId(form) {
    var input = form.querySelector('[name="id"]');
    return input ? input.value : null;
  }

  function firstVariantId(product) {
    if (!product.variants || !product.variants.length) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i].id;
    }
    return product.variants[0].id;
  }

  /* The theme's `money` filter output is not plain text. Transcy wraps every
     amount in <span class="transcy-money"> and swaps it client side per
     currency, so writing it with textContent prints the raw tag on screen
     and freezes the price in the base currency. Write it as markup, and
     only fall back to text when there is none. */
  function writeMoney(el, value) {
    if (!el) return;
    var v = value == null ? '' : String(value);
    if (v.indexOf('<') !== -1) el.innerHTML = v;
    else el.textContent = v;
  }

  function moneySpan(value) {
    var span = document.createElement('span');
    writeMoney(span, value);
    return span;
  }

  /* Image urls coming off the curated grid are ALREADY sized by the theme
     (…_500x.jpg?v=…). Splicing a second _160x in front of the extension
     produces a url the CDN does not serve, which is what broke every
     thumbnail in the colour row. Use the url exactly as given. */
  function imageUrl(url) {
    return url ? String(url) : '';
  }

  /* The theme already renders the client curated colour grid for this exact
     model as .related-products a.related-product. Reading it beats the
     recommendations endpoint, which mixes in whatever else the algorithm
     likes, shipping insurance among it. */
  function curatedColours() {
    var grid = document.querySelector('.product__info-container .related-products') ||
               document.querySelector('.related-products');
    if (!grid) return [];
    return Array.prototype.slice.call(grid.querySelectorAll('a.related-product'))
      .map(function (a) {
        var img = a.querySelector('img');
        return {
          handle: handleFromUrl(a.getAttribute('href')),
          title: a.getAttribute('title') || a.getAttribute('aria-label') || '',
          featured_image: img ? img.getAttribute('src') : null,
          variants: null
        };
      })
      .filter(function (p) { return !!p.handle; });
  }

  function handleFromUrl(url) {
    if (!url) return null;
    var m = String(url).split('?')[0].match(/\/products\/([^/]+)/);
    return m ? m[1] : null;
  }

  function resolveVariant(option) {
    if (option.variants && option.variants.length) {
      return Promise.resolve(firstVariantId(option));
    }
    if (!option.handle) return Promise.resolve(null);
    return fetch(rootUrl('products/' + option.handle + '.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { return firstVariantId(p); })
      .catch(function () { return null; });
  }

  /* A recommendations response can carry warranties, insurance and gift
     cards. Only products of the same type as the one on the page pass. */
  function sameType(items, type) {
    var want = String(type || CFG.productType || '').toLowerCase();
    if (!want) return items;
    return items.filter(function (p) {
      return String(p.type || p.product_type || '').toLowerCase() === want;
    });
  }

  /* Every request goes through the localized route the theme gives us. On
     /nl/ a hardcoded /cart/add.js still adds the line but the section HTML
     that comes back is for the wrong locale, which is one way a drawer ends
     up rendering stale or empty. */
  var R = (CFG.routes || {});

  function route(key, fallback) {
    var v = R[key];
    return (typeof v === 'string' && v) ? v : fallback;
  }

  function rootUrl(path) {
    var root = route('root', '/');
    return (root + '/' + path).replace(/\/{2,}/g, '/');
  }

  function fetchRelated(productId, limit) {
    var base = route('recommendations', '/recommendations/products');
    var url = base + (base.indexOf('.json') === -1 ? '.json' : '') +
              '?product_id=' + productId + '&limit=' + (limit || 4) + '&intent=related';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d && d.products) || []; })
      .catch(function () { return []; });
  }

  /* Adding a line has to hand the theme its own section HTML back, exactly
     the way Dawn does it. Without `sections` in the request the drawer never
     rerenders, so the item is genuinely in the cart but nothing on screen
     changes until the page is reloaded. That was the missing piece. */
  function addLines(items, button) {
    var drawer = document.querySelector('cart-drawer');
    var canRender = !!(drawer && typeof drawer.renderContents === 'function' &&
                       typeof drawer.getSectionsToRender === 'function');
    var body = { items: items };

    if (canRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    if (button) {
      button.disabled = true;
      button.setAttribute('data-kv-r4-busy', '1');
    }

    return fetch(route('cartAdd', '/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        /* Shopify answers 422 with a status field rather than throwing, so a
           sold out variant looked like a silent no-op before. */
        if (state && state.status) {
          throw new Error(state.description || state.message || 'add failed');
        }
        cartCache = null;
        if (canRender && state.sections) {
          drawer.renderContents(state);
        } else {
          openCart();
        }
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', { bubbles: true })
        );
        /* repaint our own blocks in the same tick as the theme's rerender,
           so there is no window where the drawer is missing them */
        cartModes(true);
        return state;
      })
      .catch(function (err) {
        if (button) {
          button.disabled = false;
          button.removeAttribute('data-kv-r4-busy');
          button.setAttribute('data-kv-r4-failed', '1');
          window.setTimeout(function () {
            button.removeAttribute('data-kv-r4-failed');
          }, 2400);
        }
        if (window.console && console.warn) console.warn('kv-r4 add', err);
        return null;
      })
      .then(function (state) {
        if (button) {
          button.disabled = false;
          button.removeAttribute('data-kv-r4-busy');
        }
        return state;
      });
  }

  function openCart() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    var icon = document.querySelector('#cart-icon-bubble, .header__icon--cart');
    if (icon) icon.click();
  }

  /* ======================================================================
     T81 - bundle page discovery
     ====================================================================== */
  function bundleLink() {
    var existing = document.querySelectorAll('[data-kv-r4-bundle]');
    if (!on('T81')) {
      Array.prototype.forEach.call(existing, function (n) { n.remove(); });
      return;
    }
    var url = CFG.bundleUrl || '/pages/build-your-bundle';
    var label = (CFG.labels && CFG.labels.bundle) || 'Build your set and save';

    var anchor = afterBuyAnchor();
    if (anchor && !document.querySelector('[data-kv-r4-bundle="pdp"]')) {
      var a = document.createElement('a');
      a.className = 'kv-r4 kv-r4-bundlelink';
      a.setAttribute('data-kv-r4-bundle', 'pdp');
      a.href = url;
      a.textContent = label;
      anchor.parentNode.insertBefore(a, anchor.nextSibling);
    }

    var drawerFoot = document.querySelector('.cart-drawer__footer, .drawer__footer');
    if (drawerFoot && !document.querySelector('[data-kv-r4-bundle="cart"]')) {
      var b = document.createElement('a');
      b.className = 'kv-r4 kv-r4-bundlelink';
      b.setAttribute('data-kv-r4-bundle', 'cart');
      b.href = url;
      b.textContent = label;
      drawerFoot.insertBefore(b, drawerFoot.firstChild);
    }
  }

  /* ======================================================================
     T84 - payment method order per market
     ====================================================================== */
  function paymentOrder() {
    var list = document.querySelector('.custom-payment-icons');
    if (!list) return;
    var items = Array.prototype.slice.call(list.children);
    if (!on('T84')) {
      items.forEach(function (li) {
        li.style.order = '';
        li.removeAttribute('data-kv-r4-pay-order');
      });
      return;
    }
    var first = String(CFG.payFirst || '').toLowerCase();
    items.forEach(function (li, i) {
      var title = li.querySelector('title');
      var name = (title ? title.textContent : (li.textContent || '')).toLowerCase();
      var order = name.indexOf(first) !== -1 ? -1 : i;
      li.style.order = String(order);
      li.setAttribute('data-kv-r4-pay-order', String(order));
    });
  }

  /* ======================================================================
     T75 / T76 / T77 - cart drawer modes
     ====================================================================== */
  function cartRoot() {
    return document.querySelector('cart-drawer .drawer__contents, .cart-drawer .drawer__contents, .cart-drawer');
  }

  /* One cart read per burst. boot() runs on a lot of triggers and each one
     used to fire its own /cart.js, which is where the flicker came from:
     several in-flight reads all repainting the same three blocks. */
  var cartCache = null;
  var cartPending = null;
  var cartGen = 0;

  function readCart(force) {
    if (!force && cartCache && (Date.now() - cartCache.at) < 1200) {
      return Promise.resolve(cartCache.data);
    }
    /* A forced read means something just changed the cart, so a read that
       started BEFORE that change is stale by definition. Sharing it was how
       a two item cart could still be answered with one item data. The
       generation token matters just as much: an abandoned read still
       resolves, and without it that stale payload wrote itself straight back
       into the cache a moment after the fresh one. */
    if (force) {
      cartCache = null;
      cartPending = null;
      cartGen++;
    }
    if (cartPending) return cartPending;
    var gen = cartGen;
    var url = route('cart', '/cart') ;
    if (url.indexOf('.js') === -1) url = url.replace(/\/$/, '') + '.js';
    cartPending = fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (gen !== cartGen) return cart;
        cartCache = { at: Date.now(), data: cart };
        cartPending = null;
        return cart;
      })
      .catch(function () {
        if (gen === cartGen) cartPending = null;
        return null;
      });
    return cartPending;
  }

  function cartModes(force) {
    if (!on('T75') && !on('T76') && !on('T77')) {
      cleanCart();
      return;
    }
    /* The token has to be read AFTER readCart, because a forced read is what
       increments it. Reading it first made every forced pass discard its own
       answer, which is worse than the race it was meant to close. */
    var pending = readCart(force);
    var gen = cartGen;
    pending.then(function (cart) {
      if (!cart) return;
      /* a newer read has already been asked for, so this payload is history */
      if (gen !== cartGen) return;
      if (on('T75')) setCompletion(cart); else removeAll('[data-kv-r4-set]');
      if (on('T76')) shipFix(cart); else removeAll('[data-kv-r4-shipfix]');
      if (on('T77')) colourNudge(cart); else removeAll('[data-kv-r4-colours]');
    });
  }

  function removeAll(sel) {
    Array.prototype.forEach.call(document.querySelectorAll(sel), function (n) {
      n.remove();
    });
  }

  /* Reuse the block already on screen when nothing about it changed. A
     remove plus re-append on every pass is what made the drawer blink. */
  function keep(sel, host, signature) {
    var existing = document.querySelector(sel);
    if (!existing) return false;
    if (existing.getAttribute('data-kv-r4-sig') === signature &&
        host && host.contains(existing)) {
      return true;
    }
    existing.remove();
    return false;
  }

  function cleanCart() {
    ['[data-kv-r4-set]', '[data-kv-r4-shipfix]', '[data-kv-r4-colours]'].forEach(removeAll);
  }

  function inCart(cart, variantId) {
    return cart.items.some(function (i) { return String(i.id) === String(variantId); });
  }

  /* Units currently PAINTED in the drawer. The cart read can be a moment
     behind the DOM (a burst of boots shares one in flight read, and the
     theme rerenders the drawer before our fetch resolves), so anything that
     must disappear the instant a second unit lands has to look at the
     markup as well as at the JSON. */
  function drawerUnits() {
    var lines = document.querySelectorAll('.cart-drawer .cart-item, cart-drawer .cart-item');
    if (!lines.length) return 0;
    var total = 0;
    Array.prototype.forEach.call(lines, function (line) {
      var input = line.querySelector('input[name="updates[]"], .quantity__input');
      var q = input ? parseInt(input.value, 10) : NaN;
      total += isNaN(q) ? 1 : q;
    });
    return total;
  }

  function cartUnits(cart) {
    return Math.max(cart && cart.item_count ? cart.item_count : 0, drawerUnits());
  }

  function accessoryPool(cart) {
    return ACCESSORIES.filter(function (a) {
      return !inCart(cart, a.id) && !cart.items.some(function (i) {
        return String(i.product_id) === String(a.productId);
      });
    });
  }

  function setCompletion(cart) {
    var host = document.querySelector('.cart-drawer .js-contents, cart-drawer .js-contents') ||
               document.querySelector('.drawer__cart-items-wrapper');
    if (!host || !cart.item_count) {
      removeAll('[data-kv-r4-set]');
      return;
    }

    var pool = accessoryPool(cart);
    if (!pool.length) {
      removeAll('[data-kv-r4-set]');
      return;
    }
    /* one accessory only, the cheapest add on that is not already in the
       cart. The carousel is the control, this is the challenger. */
    var pick = pool.slice().sort(function (a, b) {
      return (a.setPrice || a.price) - (b.setPrice || b.price);
    })[0];

    if (keep('[data-kv-r4-set]', host, 'set:' + pick.id)) return;

    var box = document.createElement('div');
    box.className = 'kv-r4 kv-r4-set';
    box.setAttribute('data-kv-r4-set', '1');
    box.setAttribute('data-kv-r4-sig', 'set:' + pick.id);
    box.innerHTML =
      '<p class="kv-r4-set__head"></p>' +
      '<div class="kv-r4-set__row">' +
      '<span class="kv-r4-set__media"></span>' +
      '<span class="kv-r4-set__info">' +
      '<span class="kv-r4-set__name"></span>' +
      '<span class="kv-r4-set__price"></span>' +
      '</span>' +
      '<button type="button" class="kv-r4-btn"></button>' +
      '</div>';

    box.querySelector('.kv-r4-set__head').textContent =
      (CFG.labels && CFG.labels.setHeading) || 'Goes with this bag';
    box.querySelector('.kv-r4-set__name').textContent = pick.title;

    if (pick.image) {
      var img = document.createElement('img');
      img.src = pick.image;
      img.alt = pick.title;
      img.loading = 'lazy';
      box.querySelector('.kv-r4-set__media').appendChild(img);
    }

    var priceEl = box.querySelector('.kv-r4-set__price');
    if (CFG.baseCurrency && pick.setPrice && pick.setPrice < pick.price) {
      var was = document.createElement('s');
      writeMoney(was, pick.priceText);
      priceEl.appendChild(was);
      priceEl.appendChild(moneySpan(pick.setPriceText));
    } else {
      writeMoney(priceEl, pick.priceText);
    }

    var btn = box.querySelector('.kv-r4-btn');
    btn.textContent = (CFG.labels && CFG.labels.add) || 'Add';
    btn.addEventListener('click', function () {
      addLines([{ id: pick.id, properties: { _kv_r4: 'T75', _kv_r4_addon: 'true' } }], btn);
    });

    host.appendChild(box);
  }

  function shipFix(cart) {
    var bar = document.querySelector('.cart-shipping__message.active, .cart-shipping__message_default, .tiered-shipping-bar');
    if (!bar) {
      removeAll('[data-kv-r4-shipfix]');
      return;
    }

    var threshold = (parseInt(CFG.shipThreshold, 10) || 70) * 100;
    var gap = threshold - cart.total_price;
    if (gap <= 0 || !cart.item_count) {
      removeAll('[data-kv-r4-shipfix]');
      return;
    }

    var pool = accessoryPool(cart).filter(function (a) {
      var cost = CFG.baseCurrency && a.setPrice ? a.setPrice : a.price;
      return cost >= gap;
    });
    if (!pool.length) {
      removeAll('[data-kv-r4-shipfix]');
      return;
    }

    /* the cheapest item that actually closes the gap */
    var pick = pool.sort(function (a, b) {
      var ca = CFG.baseCurrency && a.setPrice ? a.setPrice : a.price;
      var cb = CFG.baseCurrency && b.setPrice ? b.setPrice : b.price;
      return ca - cb;
    })[0];

    var host = bar.closest('.tiered-shipping-bar') || bar.parentNode;
    if (keep('[data-kv-r4-shipfix]', host.parentNode, 'ship:' + pick.id + ':' + gap)) return;

    var row = document.createElement('div');
    row.className = 'kv-r4 kv-r4-shipfix';
    row.setAttribute('data-kv-r4-shipfix', '1');
    row.setAttribute('data-kv-r4-sig', 'ship:' + pick.id + ':' + gap);

    var text = document.createElement('span');
    text.className = 'kv-r4-shipfix__text';
    var priceText = CFG.baseCurrency && pick.setPrice ? pick.setPriceText : pick.priceText;
    text.appendChild(document.createTextNode(
      ((CFG.labels && CFG.labels.shipSolve) || 'Add this and shipping is free') +
      ': ' + pick.title + ' '
    ));
    text.appendChild(moneySpan(priceText));
    row.appendChild(text);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kv-r4-btn';
    btn.textContent = (CFG.labels && CFG.labels.add) || 'Add';
    btn.addEventListener('click', function () {
      addLines([{ id: pick.id, properties: { _kv_r4: 'T76', _kv_r4_addon: 'true' } }], btn);
    });
    row.appendChild(btn);

    host.parentNode.insertBefore(row, host.nextSibling);
  }

  /* Splide ships with the theme but is only loaded on product templates, and
     the drawer is everywhere. Loading it on demand means control and every
     other mode never pay for it. */
  var splidePending = null;

  function loadSplide() {
    if (window.Splide) return Promise.resolve(window.Splide);
    if (splidePending) return splidePending;
    var js = CFG.splideJs;
    var css = CFG.splideCss;
    if (!js) return Promise.resolve(null);

    splidePending = new Promise(function (resolve) {
      if (css && !document.querySelector('link[data-kv-r4-splide]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = css;
        link.setAttribute('data-kv-r4-splide', '1');
        document.head.appendChild(link);
      }
      var tag = document.querySelector('script[data-kv-r4-splide]');
      if (!tag) {
        tag = document.createElement('script');
        tag.src = js;
        tag.setAttribute('data-kv-r4-splide', '1');
        document.head.appendChild(tag);
      }
      tag.addEventListener('load', function () { resolve(window.Splide || null); });
      tag.addEventListener('error', function () { resolve(null); });
      /* already cached and executed before we bound the listener */
      if (window.Splide) resolve(window.Splide);
    });
    return splidePending;
  }

  function mountColourRail(root) {
    if (!root || root.getAttribute('data-kv-r4-mounted') === '1') return;
    loadSplide().then(function (Splide) {
      if (!Splide || !root.isConnected) return;
      if (root.getAttribute('data-kv-r4-mounted') === '1') return;
      root.setAttribute('data-kv-r4-mounted', '1');
      try {
        /* autoWidth plus omitEnd clamps the index at the trimmed end, so prev
           resolves to the same scroll position and the back arrow dies.
           trimSpace 'move' is the option that keeps both working. */
        new Splide(root, {
          autoWidth: true,
          gap: '6px',
          arrows: true,
          pagination: false,
          trimSpace: 'move',
          omitEnd: true,
          drag: true,
          speed: 300
        }).mount();
      } catch (e) {
        root.removeAttribute('data-kv-r4-mounted');
      }
    });
  }

  /* Units of BAGS in the cart. Accessories are irrelevant to a second bag
     offer: a shopper with one bag and a carabiner has still only chosen one
     colour, so the prompt belongs there. */
  function bagUnits(cart) {
    if (!cart || !cart.items) return 0;
    var total = 0;
    cart.items.forEach(function (i) {
      if (isBagProduct(i.product_id, i.product_type)) total += (i.quantity || 1);
    });
    return total;
  }

  function firstBagIndex(cart) {
    if (!cart || !cart.items) return -1;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (isBagProduct(it.product_id, it.product_type)) return i;
    }
    return -1;
  }

  function cartLines() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.cart-drawer .cart-item, cart-drawer .cart-item')
    );
  }

  function buildColourBlock(options, sig) {
    var wrap = document.createElement('div');
    wrap.className = 'kv-r4 kv-r4-colours';
    wrap.setAttribute('data-kv-r4-colours', '1');
    wrap.setAttribute('data-kv-r4-sig', sig);

    var head = document.createElement('p');
    head.className = 'kv-r4-colours__head';
    head.textContent = ((CFG.labels && CFG.labels.secondColour) || 'Add a second colour') +
                       ' - ' + (parseInt(CFG.secondPct, 10) || 40) + '%';
    wrap.appendChild(head);

    /* Splide skeleton from the start, so mounting is a class change rather
       than a reflow, and the un-mounted state is already a usable scrolling
       row. */
    var rail = document.createElement('div');
    rail.className = 'kv-r4-colours__row splide';
    var track = document.createElement('div');
    track.className = 'splide__track';
    var list = document.createElement('ul');
    list.className = 'splide__list kv-r4-colours__list';

    options.forEach(function (o) {
      if (!o.variantId) return;
      var li = document.createElement('li');
      li.className = 'splide__slide kv-r4-colours__slide';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kv-r4-colour';
      btn.setAttribute('aria-label', o.title || '');
      if (o.image) {
        var img = document.createElement('img');
        img.src = imageUrl(o.image);
        img.alt = o.title || '';
        img.loading = 'lazy';
        btn.appendChild(img);
      }
      btn.addEventListener('click', function () {
        addLines([{ id: o.variantId, properties: { _kv_r4: 'T77', _kv_r4_second: 'true' } }], btn);
      });
      li.appendChild(btn);
      list.appendChild(li);
    });

    if (!list.children.length) return null;

    track.appendChild(list);
    rail.appendChild(track);
    wrap.appendChild(rail);

    var noteText = (CFG.labels && CFG.labels.secondColourNote) || '';
    if (noteText) {
      var note = document.createElement('p');
      note.className = 'kv-r4-colours__note';
      note.textContent = noteText;
      wrap.appendChild(note);
    }

    return { wrap: wrap, rail: rail };
  }

  function placeColourBlock(host, options, sig) {
    var built = buildColourBlock(options, sig);
    if (!built) return;
    host.appendChild(built.wrap);
    mountColourRail(built.rail);
  }

  function colourNudge(cart) {
    var lines = cartLines();
    if (!lines.length) {
      removeAll('[data-kv-r4-colours]');
      return;
    }

    /* The painted drawer is the truth about WHEN, the cart JSON is the truth
       about WHAT. If the two disagree the read is behind the screen, so do
       nothing this pass and let the next forced read handle it — appending on
       a stale count is how the prompt ended up under a cart that had already
       grown. */
    if (drawerUnits() !== cart.item_count) {
      removeAll('[data-kv-r4-colours]');
      return;
    }

    /* exactly one bag. Two bags means the question has been answered;
       accessories alongside the bag do not count either way. */
    if (bagUnits(cart) !== 1) {
      removeAll('[data-kv-r4-colours]');
      return;
    }

    var index = firstBagIndex(cart);
    var item = cart.items[index];
    var host = lines[index];
    if (!item || !host) {
      removeAll('[data-kv-r4-colours]');
      return;
    }

    /* every product id already in the cart, so a colour the shopper has
       cannot be offered back to them */
    var inCartIds = {};
    cart.items.forEach(function (i) { inCartIds[String(i.product_id)] = true; });

    var sig = 'col:' + item.product_id + ':' + cart.item_count;
    if (keep('[data-kv-r4-colours]', host, sig)) return;

    /* Preferred path: the whole colour range of the model in the cart, read
       straight from the registry. No fetch, no race, and no chance of another
       model turning up in the row. */
    var colours = sameCollectionColours(item.product_id, inCartIds);
    if (colours) {
      if (!colours.length) {
        removeAll('[data-kv-r4-colours]');
        return;
      }
      placeColourBlock(host, colours, sig);
      return;
    }

    /* Fallback only for a bag recognised by type but not present in any
       collection group, e.g. one past the Liquid loop ceiling. */
    var unitsAtStart = drawerUnits();
    fetchRelated(item.product_id, 10).then(function (items) {
      var options = sameType(items, item.product_type).filter(function (p) {
        return !inCartIds[String(p.id)] &&
               isBagProduct(p.id, p.type || p.product_type);
      }).map(function (p) {
        return {
          id: p.id,
          variantId: firstVariantId(p),
          title: p.title,
          image: p.featured_image
        };
      });
      if (!options.length) return;

      var liveLines = cartLines();
      var live = liveLines[index];
      if (!live) return;
      if (drawerUnits() !== unitsAtStart) {
        removeAll('[data-kv-r4-colours]');
        return;
      }
      if (keep('[data-kv-r4-colours]', live, sig)) return;

      placeColourBlock(live, options, sig);
    });
  }

  /* ======================================================================
     Preview panel
     ====================================================================== */
  function panel() {
    var host = document.querySelector('[data-kv-r4-panel]');
    if (!host || host.getAttribute('data-kv-r4-panel-built') === '1') return;
    host.setAttribute('data-kv-r4-panel-built', '1');
    host.hidden = false;

    var list = host.querySelector('[data-kv-r4-panel-list]');
    var body = host.querySelector('[data-kv-r4-panel-body]');
    var toggle = host.querySelector('[data-kv-r4-panel-toggle]');

    function group(title) {
      var h = document.createElement('p');
      h.className = 'kv-r4-panel__group';
      h.textContent = title;
      list.appendChild(h);
    }

    function row(id, isNeighbour) {
      var label = document.createElement('label');
      var input = document.createElement('input');
      input.type = 'checkbox';
      input.checked = on(id);
      input.setAttribute('data-kv-r4-panel-id', id);
      input.addEventListener('change', function () {
        if (isNeighbour) {
          setNeighbour(id, input.checked);
        } else {
          overridden[id] = input.checked;
          root.classList.toggle('kv-' + id.toLowerCase(), input.checked);
        }
        boot();
      });
      label.appendChild(input);
      label.appendChild(document.createTextNode(LABELS[id] || id));
      list.appendChild(label);
    }

    group('Round 4');
    IDS.forEach(function (id) { row(id, false); });
    group('Upsells and slider');
    NEIGHBOURS.forEach(function (id) { row(id, true); });

    toggle.addEventListener('click', function () {
      var open = body.hidden;
      body.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    });

    host.querySelector('[data-kv-r4-panel-all]').addEventListener('click', function () {
      setAll(true, list);
    });
    host.querySelector('[data-kv-r4-panel-none]').addEventListener('click', function () {
      setAll(false, list);
    });
  }

  function setAll(state, list) {
    IDS.forEach(function (id) {
      overridden[id] = state;
      root.classList.toggle('kv-' + id.toLowerCase(), state);
    });
    NEIGHBOURS.forEach(function (id) { setNeighbour(id, state); });
    Array.prototype.forEach.call(list.querySelectorAll('input'), function (i) {
      i.checked = state;
    });
    boot();
  }

  /* ======================================================================
     T79 - compact cookie bar
     Consentmo renders <csm-cookie-consent> with an OPEN shadow root, so
     the page rules in kv-tests-r4.css never reach the banner box - that
     is why the bar stayed centered with the mode on. The rules have to be
     injected INTO the shadow root. Everything is keyed on a data-kv-t79
     attribute on the HOST element, so switching the mode off removes one
     attribute and the stock banner comes back exactly, style sheet and
     marker attributes left in place.

     The banner box is found by shape, not by class name: any element in
     the shadow root that computes position fixed and is visible right now.
     A fixed element covering (nearly) the whole viewport is an overlay and
     gets bottom aligned instead; its child then becomes the strip via the
     child rule. The visibility gate matters twice over: it skips the
     hidden preferences modal that lives in the same shadow root, and it
     means a banner that has not painted yet is retried rather than
     mismarked.
     ====================================================================== */
  var T79_SHADOW_CSS =
    ':host([data-kv-t79]) [data-kv-t79-strip]{' +
      'position:fixed!important;top:auto!important;bottom:0!important;' +
      'left:0!important;right:0!important;transform:none!important;' +
      'width:100%!important;max-width:none!important;min-width:0!important;' +
      'box-sizing:border-box!important;' +
      'margin:0!important;border-radius:0!important;padding:10px 14px!important;' +
      'box-shadow:0 -1px 0 rgba(0,0,0,0.08)!important;' +
      'display:flex!important;flex-wrap:wrap;align-items:center!important;' +
      'justify-content:space-between;gap:8px 12px!important;' +
    '}' +
    ':host([data-kv-t79]) [data-kv-t79-overlay]{' +
      'display:flex!important;align-items:flex-end!important;' +
      'justify-content:stretch!important;padding:0!important;' +
      'background:transparent!important;' +
    '}' +
    ':host([data-kv-t79]) [data-kv-t79-overlay] > *{' +
      'width:100%!important;max-width:none!important;margin:0!important;' +
      'box-sizing:border-box!important;' +
      'border-radius:0!important;transform:none!important;' +
      'padding:10px 14px!important;' +
      'box-shadow:0 -1px 0 rgba(0,0,0,0.08)!important;' +
      'display:flex!important;flex-wrap:wrap;align-items:center!important;' +
      'justify-content:space-between;gap:8px 12px!important;' +
    '}' +
    ':host([data-kv-t79]) [data-kv-t79-strip] p,' +
    ':host([data-kv-t79]) [data-kv-t79-overlay] p{' +
      'margin:0!important;font-size:1.2rem!important;line-height:1.35!important;' +
    '}' +
    ':host([data-kv-t79]) [data-kv-t79-strip] button,' +
    ':host([data-kv-t79]) [data-kv-t79-strip] a[class*="btn"],' +
    ':host([data-kv-t79]) [data-kv-t79-overlay] button,' +
    ':host([data-kv-t79]) [data-kv-t79-overlay] a[class*="btn"]{' +
      'padding:8px 16px!important;font-size:1.3rem!important;' +
      'white-space:nowrap;margin:0!important;' +
    '}' +
    /* The strip height must come from the row of content, nothing else.
       min-height on the window and padding on the inner wrappers is what
       made the bar tall with the row floating in the middle of it. */
    ':host([data-kv-t79]) [data-kv-t79-strip],' +
    ':host([data-kv-t79]) [data-kv-t79-overlay] > *{' +
      'min-height:0!important;height:auto!important;' +
    '}' +
    ':host([data-kv-t79]) [data-kv-t79-flat]{' +
      'display:block!important;position:static!important;' +
      'padding:0!important;margin:0!important;' +
      'width:100%!important;max-width:none!important;' +
      'min-height:0!important;height:auto!important;' +
      'transform:none!important;background:transparent!important;' +
    '}' +
    ':host([data-kv-t79]) [data-kv-t79-row]{' +
      'display:flex!important;flex-wrap:wrap;align-items:center!important;' +
      'justify-content:center;gap:8px 12px!important;' +
      'position:static!important;padding:0!important;margin:0!important;' +
      'width:100%!important;max-width:none!important;' +
      'min-height:0!important;height:auto!important;' +
    '}' +
    ':host([data-kv-t79]) [data-kv-t79-row] > *,' +
    ':host([data-kv-t79]) [data-kv-t79-strip] > *{' +
      'margin:0!important;min-height:0!important;align-self:center!important;' +
    '}' +
    /* The message element gets its own marker so its box padding cannot
       push the text off the vertical centre, and so the size can step up
       on desktop without touching the buttons. */
    ':host([data-kv-t79]) [data-kv-t79-msg]{' +
      'padding:0!important;margin:0!important;' +
      'font-size:1.2rem!important;line-height:1.4!important;' +
      'flex:1 1 auto;min-width:0;' +
    '}' +
    '@media (min-width:750px){' +
      ':host([data-kv-t79]) [data-kv-t79-msg],' +
      ':host([data-kv-t79]) [data-kv-t79-msg] p,' +
      ':host([data-kv-t79]) [data-kv-t79-strip] p,' +
      ':host([data-kv-t79]) [data-kv-t79-overlay] p{' +
        'font-size:1.4rem!important;' +
      '}' +
    '}';

  /* The banner box usually wraps the visible row in one or two full-bleed
     containers that carry the card's padding, min-height and max-width.
     Walk the single-child chain down from the box, flatten every wrapper
     on the way, and turn the first element with several children into the
     content row. A box whose children are the row already needs nothing:
     the strip's own flex plus the child margin reset handle it. */
  function t79Flatten(box) {
    var node = box;
    var guard = 0;
    while (guard < 6) {
      guard += 1;
      var kids = [];
      for (var i = 0; i < node.children.length; i++) {
        var k = node.children[i];
        var t = k.tagName;
        if (t === 'STYLE' || t === 'SCRIPT' || t === 'LINK' || t === 'TEMPLATE') continue;
        if (window.getComputedStyle(k).display === 'none') continue;
        kids.push(k);
      }
      if (kids.length !== 1) break;
      node = kids[0];
      node.setAttribute('data-kv-t79-flat', '');
    }
    if (node !== box) {
      node.removeAttribute('data-kv-t79-flat');
      node.setAttribute('data-kv-t79-row', '');
    }
    /* whichever element ended up holding the children, mark the text ones */
    for (var m = 0; m < node.children.length; m++) {
      var c = node.children[m];
      var ct = c.tagName;
      if (ct === 'STYLE' || ct === 'SCRIPT' || ct === 'LINK' || ct === 'TEMPLATE') continue;
      if (ct === 'BUTTON' || ct === 'A' || ct === 'INPUT') continue;
      if (c.querySelector('button, input, a[class*="btn"]')) continue;
      if (!(c.textContent || '').replace(/\s+/g, '')) continue;
      c.setAttribute('data-kv-t79-msg', '');
    }
  }

  var t79Tries = 0;

  function t79Retry() {
    if (t79Tries >= 20) return;
    t79Tries += 1;
    setTimeout(t79, 400);
  }

  function t79() {
    var host = document.querySelector('csm-cookie-consent');
    var active = on('T79');
    if (!host) {
      /* the app injects after us, so keep looking while the mode is on */
      if (active) t79Retry();
      return;
    }
    if (!active) {
      host.removeAttribute('data-kv-t79');
      return;
    }

    var sr = host.shadowRoot;
    var scope = sr || host;

    if (sr && !sr.querySelector('[data-kv-t79-style]')) {
      var st = document.createElement('style');
      st.setAttribute('data-kv-t79-style', '');
      st.textContent = T79_SHADOW_CSS;
      sr.appendChild(st);
    }

    var marked = !!scope.querySelector('[data-kv-t79-strip],[data-kv-t79-overlay]');
    var nodes = scope.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var tag = el.tagName;
      if (tag === 'STYLE' || tag === 'SCRIPT' || tag === 'LINK' || tag === 'TEMPLATE') continue;
      if (el.hasAttribute('data-kv-t79-strip') || el.hasAttribute('data-kv-t79-overlay')) continue;
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed') continue;
      if (cs.display === 'none' || cs.visibility === 'hidden') continue;
      var rect = el.getBoundingClientRect();
      if (rect.width < 1 || rect.height < 1) continue;
      var overlay = rect.width >= window.innerWidth * 0.9 &&
                    rect.height >= window.innerHeight * 0.9;
      el.setAttribute(overlay ? 'data-kv-t79-overlay' : 'data-kv-t79-strip', '');
      marked = true;
    }

    /* runs every pass: re-marking is idempotent and covers content the app
       swaps in after the first paint */
    Array.prototype.forEach.call(scope.querySelectorAll('[data-kv-t79-strip]'), t79Flatten);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-kv-t79-overlay]'), function (ov) {
      for (var j = 0; j < ov.children.length; j++) {
        var c = ov.children[j];
        var ct = c.tagName;
        if (ct === 'STYLE' || ct === 'SCRIPT' || ct === 'LINK' || ct === 'TEMPLATE') continue;
        if (window.getComputedStyle(c).display === 'none') continue;
        t79Flatten(c);
      }
    });

    if (marked) {
      host.setAttribute('data-kv-t79', '');
    } else {
      /* element is there, banner has not painted yet */
      t79Retry();
    }
  }

  /* ======================================================================
     Boot
     ====================================================================== */
  var booting = false;

  /* An Intelligems arm can change a number without touching theme settings:
       window.kvR4Overrides = { galleryKeep: 8 };
     Read on every boot, so the order the two scripts load in does not matter.
     Nested objects (labels) are merged key by key. */
  function applyOverrides() {
    var o = window.kvR4Overrides;
    if (!o || typeof o !== 'object') return;
    Object.keys(o).forEach(function (k) {
      if (o[k] && typeof o[k] === 'object' && !Array.isArray(o[k]) && CFG[k] && typeof CFG[k] === 'object') {
        Object.keys(o[k]).forEach(function (n) { CFG[k][n] = o[k][n]; });
      } else {
        CFG[k] = o[k];
      }
    });
  }

  function boot() {
    if (booting) return;
    booting = true;
    applyOverrides();
    try {
      t66();
      t67();
      t68();
      modelTabs();
      pdpBlocks();
      pageBlocks();
      menuBlock();
      twoColours();
      bundleLink();
      paymentOrder();
      cartModes();
      t79();
    } catch (e) {
      if (window.console && console.warn) console.warn('kv-r4', e);
    }
    booting = false;
  }

  /* Our own inserts land inside the drawer, so an unfiltered observer would
     see them, rerun, insert again and never settle. Every record that only
     touches R4 nodes is ignored, and everything else is debounced. */
  var OURS = '[data-kv-r4-set],[data-kv-r4-shipfix],[data-kv-r4-colours],[data-kv-r4-bundle]';

  function isOurs(node) {
    if (!node || node.nodeType !== 1) return true;
    if (node.matches && node.matches(OURS)) return true;
    return !!(node.closest && node.closest(OURS));
  }

  function onlyOurs(records) {
    return records.every(function (r) {
      return Array.prototype.every.call(r.addedNodes, isOurs) &&
             Array.prototype.every.call(r.removedNodes, isOurs);
    });
  }

  function debounce(fn, wait) {
    var t = null;
    return function () {
      if (t) clearTimeout(t);
      t = setTimeout(fn, wait || 60);
    };
  }

  /* ---- shareable preview links -------------------------------------------
     ?kv=t66            show that one mode and nothing else
     ?kv=t66,t80        show a combination
     ?kv=all            everything at once
     ?kv=off            control, exactly what a customer sees today
     The choice is kept in sessionStorage so browsing on from the landing
     page does not drop the mode, and it also un-gates the matching R2 and
     R3 markers so a link can preview T60 or T65 the same way.
  ------------------------------------------------------------------------ */
  function previewParam() {
    var raw = null;
    try {
      var qs = new URLSearchParams(window.location.search);
      if (qs.has('kv')) {
        raw = qs.get('kv');
        window.sessionStorage.setItem('kvR4Preview', raw);
      } else {
        raw = window.sessionStorage.getItem('kvR4Preview');
      }
    } catch (e) {
      return;
    }
    if (raw === null) return;

    var value = String(raw).trim().toLowerCase();
    if (value === 'off' || value === 'none' || value === 'control' || value === '') {
      IDS.forEach(function (id) {
        overridden[id] = false;
        root.classList.remove('kv-' + id.toLowerCase());
      });
      NEIGHBOURS.forEach(function (id) { setNeighbour(id, false); });
      return;
    }
    if (value === 'all' || value === 'r4') {
      /* set the class directly, do not lean on the markers: on the shipped
         theme every marker is gated, so syncModes would find nothing */
      IDS.forEach(function (id) {
        overridden[id] = true;
        root.classList.add('kv-' + id.toLowerCase());
      });
      if (value === 'all') NEIGHBOURS.forEach(function (id) { setNeighbour(id, true); });
      return;
    }
    if (value === 'upsells') {
      ['T75', 'T76', 'T77', 'T80', 'T81'].forEach(function (id) {
        overridden[id] = true;
        root.classList.add('kv-' + id.toLowerCase());
      });
      NEIGHBOURS.forEach(function (id) { setNeighbour(id, true); });
      return;
    }

    var wanted = {};
    value.split(',').forEach(function (part) {
      var id = part.trim().replace(/[^a-z0-9]/g, '');
      if (id) wanted[id] = true;
    });

    IDS.forEach(function (id) {
      var want = !!wanted[id.toLowerCase()];
      overridden[id] = want;
      root.classList.toggle('kv-' + id.toLowerCase(), want);
    });

    /* R2 and R3 modes are not ours to sync, so reveal their marker and set
       the class. Both layers re-read on a html class mutation and on their
       own delayed passes, so the block appears without a reload. */
    NEIGHBOURS.forEach(function (id) {
      setNeighbour(id, !!wanted[id.toLowerCase()]);
    });
    Object.keys(wanted).forEach(function (id) {
      var up = id.toUpperCase();
      if (IDS.indexOf(up) !== -1 || NEIGHBOURS.indexOf(up) !== -1) return;
      root.classList.add('kv-' + id);
      var marker = document.querySelector('[data-kv-test="' + up + '"]');
      if (marker) marker.classList.remove('kv-tt-gated');
    });
  }

  var started = false;

  function start() {
    /* DOMContentLoaded can reach us twice (a harness dispatching it by hand,
       or an app replaying the event). Without this guard the observers bind
       twice and previewParam re-applies the stored link, which silently
       undoes anything switched off in the panel. */
    if (started) return;
    started = true;
    previewParam();
    syncModes();
    panel();
    boot();

    var reboot = debounce(function () {
      syncModes();
      boot();
    }, 60);

    new MutationObserver(reboot)
      .observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    var drawer = document.querySelector('cart-drawer, .cart-drawer');
    if (drawer) {
      var drawerRefresh = debounce(function () {
        cartModes(true);
        bundleLink();
      }, 80);
      new MutationObserver(function (records) {
        if (onlyOurs(records)) return;
        drawerRefresh();
      }).observe(drawer, { childList: true, subtree: true });
    }

    document.addEventListener('cart:change', debounce(function () { cartModes(true); }, 80));
    document.documentElement.addEventListener('cart:change', debounce(function () {
      cartCache = null;
      cartModes(true);
    }, 80));
    window.addEventListener('resize', debounce(function () { t68(); }, 120));
    window.addEventListener('orientationchange', function () { t68(); });
    window.addEventListener('load', function () { boot(); });
  }

  /* Public helper. The recommended Intelligems route stays classList.add,
     this is for QA and for arms that want to set a value and reboot. */
  window.kvR4 = {
    on: function (ids) {
      String(ids).split(',').forEach(function (id) {
        var key = id.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
        if (!key) return;
        var up = key.toUpperCase();
        if (NEIGHBOURS.indexOf(up) !== -1) return setNeighbour(up, true);
        overridden[up] = true;
        root.classList.add('kv-' + key);
      });
      boot();
    },
    off: function (ids) {
      String(ids).split(',').forEach(function (id) {
        var key = id.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
        if (!key) return;
        var up = key.toUpperCase();
        if (NEIGHBOURS.indexOf(up) !== -1) return setNeighbour(up, false);
        overridden[up] = false;
        root.classList.remove('kv-' + key);
      });
      boot();
    },
    set: function (key, value) {
      window.kvR4Overrides = window.kvR4Overrides || {};
      window.kvR4Overrides[key] = value;
      boot();
    },
    config: CFG,
    boot: boot
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
